// export { default as Logo } from "./logo.svg";
export { default as Logo } from "./logo.png";
export { default as LogoPNG } from "./logo.png";
export { default as IconsChrome } from "./icons_chrome.png";
export { default as IconsSafari } from "./icons_safari.png";
export { default as LogoFotor } from "./logo_fotor.png";
export { default as IconsBrowser } from "./icons_browser.png";
export { default as IconsMore } from "./icons_more.png";
export { default as ShadowArrow } from "./shadow_arrow.png";
export { default as ShadowIOSEn } from "./shadow_ios_en.png";
export { default as ShadowIOSZh } from "./shadow_ios_zh.png";
export { default as ShadowAndroidEn } from "./shadow_android_en.png";
export { default as ShadowAndroidZh } from "./shadow_android_zh.png";
export { default as clear } from "./clear.png";
